import { RebaseTranslations } from "@rebasepro/cms-types";

export const fr: RebaseTranslations = {
    // ─── Form actions ────────────────────────────────────────────
    save: "Enregistrer",
    create: "Créer",
    create_copy: "Créer une copie",
    save_and_close: "Enregistrer et fermer",
    create_copy_and_close: "Créer une copie et fermer",
    create_and_close: "Créer et fermer",
    discard: "Ignorer",
    clear: "Effacer",
    cancel: "Annuler",

    // ─── Entity actions ──────────────────────────────────────────
    edit: "Modifier",
    copy: "Copier",
    delete: "Supprimer",
    delete_not_allowed: "Vous avez sélectionné au moins une entité que vous ne pouvez pas supprimer",
    edit_entity: "Modifier",
    back_to_detail: "Retour aux détails",

    // ─── Delete dialog ───────────────────────────────────────────
    delete_confirmation_title: "Supprimer ?",
    delete_confirmation_body: "Cela supprimera l'entité. Êtes-vous sûr ?",
    delete_multiple_confirmation_body: "Cela supprimera les entités sélectionnées. Êtes-vous sûr ?",

    // ─── Unsaved-changes dialog ───────────────────────────────────
    unsaved_changes_title: "Modifications non enregistrées",
    unsaved_changes_body: "Vous avez des modifications non enregistrées. Voulez-vous les ignorer ?",
    discard_changes: "Ignorer les modifications",
    keep_editing: "Continuer l'édition",
    clear_form: "Vider le formulaire ?",
    discard_changes_confirmation: "Toutes les modifications non enregistrées seront perdues. Cette action est irréversible.",
    clear_form_confirmation: "Toutes les valeurs saisies seront effacées. Cette action est irréversible.",

    // ─── Collection table / toolbar ──────────────────────────────
    search: "Rechercher",
    find_by_id: "Rechercher par ID",
    find_entity_by_id: "Rechercher l'entité par ID",
    filter: "Filtrer",
    filters: "Filtres",
    records_in_view: "Enregistrements dans cette vue",
    clear_filter: "Effacer le filtre",
    clear_filter_sort: "Effacer le filtre/tri",
    clear_sort: "Effacer le tri",
    sort: "Trier",
    sort_by: "Trier par",
    sort_then_by: "Puis par",
    sort_ascending: "Trier par ordre croissant",
    sort_descending: "Trier par ordre décroissant",
    sort_remove: "Supprimer le tri",
    sort_move_up: "Rendre cette clé plus importante",
    sort_move_down: "Rendre cette clé moins importante",
    sort_remove_key: "Supprimer cette clé de tri",
    sort_key_position: "Clé de tri {{position}}",
    sort_shift_click_hint: "Maj+clic pour ajouter une colonne sous le tri actuel",
    save_entity_before_subcollections: "Vous devez enregistrer l'entité avant d'ajouter des collections supplémentaires",
    clear_all: "Tout effacer",
    no_items: "Aucun élément",
    no_entries_found: "Aucune entrée trouvée",
    all_entries_loaded: "Toutes les {{count}} entrées chargées",
    create_your_first_entry: "Créez votre première entrée",
    no_results_filter_sort: "Aucun résultat avec le filtre/tri appliqué",
    no_results_search: "Aucun résultat trouvé pour \"{{search}}\"",
    add: "Ajouter",
    remove: "Supprimer",
    multiple_entities: "Entités multiples",
    unsaved_changes: "Vous avez des modifications non enregistrées dans {{collectionName}}.",
    so_empty: "C'est bien vide...",
    no_results: "Aucun résultat avec le filtre/tri appliqué",
    refresh_data: "Actualiser les données",
    dark_mode: "Sombre",
    light_mode: "Clair",
    system_mode: "Système",
    join_newsletter: "Rejoignez la newsletter, pas de spam",
    ok: "Ok",
    save_collection_config: "Enregistrer la structure de la collection",
    search_for_more_icons: "Rechercher d'autres icônes…",
    ai_modified: "Modifié par l'IA",
    size_label: "Taille",
    group_by: "Grouper par",
    initialize_kanban_order: "Initialiser l'ordre Kanban",
    copy_id: "Copier l'ID",
    add_specific: "Ajouter {{name}}",
    add_named: "Ajouter « {{name}} »",
    select_specific: "Sélectionner {{name}}",
    select_from: "Sélectionner depuis {{name}}",
    done: "Terminé",
    log_out: "Se déconnecter",
    column_cannot_be_edited: "Cette colonne ne peut pas être modifiée directement",
    close: "Fermer",
    hide_list: "Masquer la liste",
    show_list: "Afficher la liste",
    unsaved_local_changes: "Modifications locales non enregistrées",
    unsaved_local_changes_description: "Ce document a été modifié localement et contient des modifications non enregistrées. Ces modifications locales seront perdues si vous ne les appliquez pas.",
    preview_changes: "Aperçu des modifications",
    apply_changes: "Appliquer les modifications",
    discard_local_changes: "Ignorer les modifications locales",
    preview_local_changes: "Aperçu des modifications locales",
    preview_local_changes_description: "Voici les modifications locales qui seront appliquées au formulaire.",
    type: "Type",
    string: "chaîne de caractères",
    number: "nombre",
    boolean: "booléen",
    date: "date",
    map: "carte (map)",
    array: "tableau",
    arrays_of_arrays_not_supported: "Les tableaux de tableaux ne sont pas pris en charge.",
    data_type_not_supported: "Type de données {{dataType}} non pris en charge pour le moment",
    passkey_error_unsupported: "Votre appareil ou navigateur ne prend pas en charge les passkeys.",

    // ─── Entity form feedback ─────────────────────────────────────
    saved_correctly: "Enregistré avec succès",
    error_before_saving: "Erreur lors de la préparation des données",
    error_after_saving: "Erreur dans le traitement post-sauvegarde",
    error_saving_entity: "Erreur lors de l'enregistrement de l'entité",
    entity_does_not_exist: "Cette entité n'existe pas dans la base de données",
    form_modified: "Ce formulaire a été modifié",
    form_in_sync: "Le formulaire actuel est synchronisé avec la base de données",
    fix_errors_before_saving: "Corrigez les erreurs signalées avant d'enregistrer",

    admin: "Admin",
    home: "Accueil",
    this_form_has_errors: "Ce formulaire contient des erreurs",
    error_loading_navigation: "Erreur lors du chargement de la navigation",
    error_loading_auth: "Erreur lors du chargement de l'authentification",
    this_form_has_been_modified: "Ce formulaire a été modifié",
    current_form_in_sync: "Le formulaire actuel est synchronisé avec la base de données",
    open_in_console: "Ouvrir dans la console",
    collection_does_not_exist: "La collection spécifiée n'existe pas. Vérifiez la console",
    unexpected_value: "Valeur inattendue",
    unexpected_value_click_to_edit: "Valeur inattendue. Cliquez pour modifier",
    unexpected_reference_value: "Valeur de référence inattendue. Cliquez pour modifier",
    copy_url_to_clipboard: "Copier l'URL dans le presse-papiers",
    open_image_in_new_tab: "Ouvrir l'image dans un nouvel onglet",
    reference_not_set: "Référence non définie",
    reference_does_not_exist: "La référence n'existe pas",
    entity_not_found: "Entité non trouvée",
    entity_not_found_body: "Cet enregistrement n'existe pas, ou il vous est masqué par la sécurité au niveau des lignes.",
    back_to_collection: "Retour à {{name}}",
    file_not_found: "Fichier non trouvé",
    unsaved_changes_in_entity: "Vous avez des modifications non enregistrées dans cette entité.",
    delete_this_role: "Supprimer ce rôle",
    no_roles_yet: "Vous n'avez pas encore de rôles.",
    create_default_roles: "Créer les rôles par défaut",
    delete_role_confirmation: "Êtes-vous sûr de vouloir supprimer ce rôle ?",
    delete_this_user: "Supprimer cet utilisateur",
    no_users_yet: "Il n'y a pas encore d'utilisateurs",
    add_logged_user_as_admin: "Ajouter l'utilisateur connecté en tant qu'administrateur",
    add_current_user_as_admin: "Ajouter l'utilisateur actuel en tant qu'administrateur",
    create_default_roles_and_add_admin: "Créer les rôles par défaut et ajouter l'utilisateur actuel en tant qu'administrateur",
    delete_user_confirmation: "Êtes-vous sûr de vouloir supprimer cet utilisateur ?",
    create_your_users_and_roles: "Créez vos utilisateurs et rôles",
    no_users_or_roles_defined: "Vous n'avez défini aucun utilisateur ni rôle. Vous pouvez créer les rôles par défaut et ajouter l'utilisateur actuel en tant qu'administrateur.",
    save_before_changing_schema: "Vous devez enregistrer le document avant de modifier le schéma",
    edit_schema_for_this_form: "Modifier le schéma de ce formulaire",
    no_permissions_to_edit_collection: "Vous n'avez pas l'autorisation de modifier cette collection",
    browser_does_not_support_audio: "Votre navigateur ne prend pas en charge l'élément audio.",
    user_not_found: "Utilisateur introuvable : {{value}}",

    // ─── Collection view actions ──────────────────────────────────
    delete_selected: "Supprimer la sélection",
    cannot_delete_selected: "Vous avez sélectionné au moins une entité que vous ne pouvez pas supprimer",

    // ─── Array / field containers ─────────────────────────────────
    add_entry: "Ajouter",
    add_on_top: "Ajouter en haut",
    add_below: "Ajouter en dessous",
    add_to_field: "Ajouter à {{fieldName}}",
    value: "Valeur",
    key: "Clé",
    drag_drop_multiple: "Faites glisser et déposez des fichiers ici, ou cliquez pour sélectionner des fichiers. Faites glisser pour réorganiser.",
    drag_drop_single: "Faites glisser et déposez un fichier ici, ou cliquez pour en sélectionner un",

    // ─── Navigation / scaffold ────────────────────────────────────
    open_menu: "Ouvrir le menu",
    close_drawer: "Fermer le menu latéral",
    navigation_drawer: "Tiroir de navigation",
    collapse: "Réduire",
    expand: "Développer",
    change_language: "Changer de langue",
    toggle_theme: "Changer de thème",
    user_menu: "Menu utilisateur",

    // ─── Error states ─────────────────────────────────────────────
    error: "Erreur",
    error_loading_data: "Impossible de charger les données",
    error_check_server_logs: "Consultez les journaux du serveur pour plus de détails.",
    error_technical_details: "Détails techniques",
    error_uploading_file: "Erreur lors du téléchargement du fichier",
    error_deleting: "Erreur lors de la suppression",
    error_before_delete: "Erreur avant la suppression",
    error_updating_asset: "Erreur lors de la mise à jour de l'actif",
    error_deleting_asset: "Erreur lors de la suppression de l'actif",
    error_firestore_index: "Un index Firestore est requis pour cette requête.",
    create_index: "Créer un index",
    value_is_not_reference: "La valeur n'est pas une référence.",
    click_to_edit: "Cliquez pour modifier",
    data_is_not_array_of_references: "Les données ne sont pas un tableau de références",

    // ─── Misc ─────────────────────────────────────────────────────
    loading: "Chargement...",
    local_changes_applied: "Modifications locales appliquées au formulaire",
    local_changes_discarded: "Modifications locales ignorées",
    are_you_sure_leave: "Êtes-vous sûr de vouloir quitter cette page ?",
    see_console_details: "Consultez la console pour plus de détails.",
    drop_here_create_group: "Déposez ici pour créer un nouveau groupe",
    filter_for_null_values: "Filtrer les valeurs nulles",
    value_updated_elsewhere: "Cette valeur a été mise à jour ailleurs",
    add_property: "Ajouter une propriété",
    edit_name: "Modifier {{name}}",
    this_entity_not_exist: "Cette entité n'existe pas dans la base de données",
    internal_error: "ERREUR interne",

    // ─── Rename group dialog ──────────────────────────────────────
    rename_group: "Renommer le groupe",
    group_name_label: "Nom du groupe",
    group_name_empty_error: "Le nom du groupe ne peut pas être vide.",
    group_name_exists_error: "Ce nom de groupe existe déjà.",

    // ─── Search ───────────────────────────────────────────────────
    search_collections: "Rechercher dans les collections",

    // ─── Navigation groups ────────────────────────────────────────
    views_group: "Vues",

    // ─── Entity Edit View ─────────────────────────────────────────
    youd_need_to_save_before_additional_collections: "Vous devez enregistrer votre entité avant d'ajouter des collections supplémentaires",

    // ─── Not Found Page ───────────────────────────────────────────
    page_not_found: "Page introuvable",
    page_not_found_body: "Cette page n'existe pas ou vous n'y avez peut-être pas accès",
    back_to_home: "Retour à l'accueil",

    // ─── Collection Editor ─────────────────────────────────────────
    default_collection_view: "Vue de collection par défaut",
    table_view: "Tableau",
    cards_view: "Cartes",
    kanban_view: "Kanban",
    choose_how_entities_displayed_default: "Choisissez comment les entités doivent être affichées par défaut",

    document_view: "Vue de document",
    side_panel: "Panneau latéral",
    full_screen: "Plein écran",
    should_documents_opened_full_screen: "Les documents doivent-ils être ouverts en plein écran ou dans une boîte de dialogue latérale intégrée",

    select_custom_view: "Sélectionner une vue personnalisée",
    no_custom_views_defined: "Aucune vue personnalisée n'est définie. Définissez vos vues personnalisées dans les paramètres de personnalisation, avant d'utiliser cette boîte de dialogue.",

    select_custom_action: "Sélectionner une action personnalisée",
    no_custom_actions_defined: "Aucune action personnalisée définie. Définissez vos actions personnalisées dans les paramètres de personnalisation, avant d'utiliser cette boîte de dialogue.",

    no_collections_found: "Aucune collection trouvée",
    start_building_collections: "Commencez à créer des collections dans Rebase facilement. Mappez-les à vos données de base de données existantes, importez-les à partir de fichiers ou utilisez nos modèles.",
    create_first_collection: "Créez votre première collection",
    define_collections_programmatically: "Vous pouvez également définir des collections par programmation.",
    edit_collection: "Modifier la collection",
    no_permissions_edit_collection: "Vous n'avez pas les autorisations pour modifier cette collection",
    no_permissions_create_collection: "Vous n'avez pas les autorisations pour créer des collections",
    create_collection: "Créer une collection",
    update_collection: "Mettre à jour la collection",

    new_collection: "Nouvelle collection",
    add_new_collection: "Ajouter une nouvelle collection",
    collection_with_name: "Collection {{name}}",
    change_icon: "Changer l'icône",
    is_subcollection_of: "Ceci est une sous-collection de",
    name: "Nom",
    collection_name_description: "Nom de cette collection, généralement un nom au pluriel (par ex., Produits)",
    path: "Chemin",
    relative_path_to_parent: "Chemin relatif vers le parent (il n'est pas nécessaire d'inclure le chemin parent)",
    path_in_database: "Chemin dans lequel cette collection est stockée, dans la base de données",
    singular_name: "Nom au singulier",
    singular_name_description: "Définissez éventuellement un nom au singulier pour vos entités",
    description: "Description",
    description_of_collection: "Description de la collection, vous pouvez utiliser le format markdown",
    collection_id: "ID de la collection",
    collection_id_description: "Cet ID identifie cette collection. Généralement le même que le chemin.",
    collection_group: "Groupe de collections",
    collection_group_description: "Un groupe de collections se compose de toutes les collections ayant le même chemin. Cela vous permet d'effectuer des requêtes sur plusieurs collections à la fois.",
    advanced_settings: "Paramètres avancés",
    doc_history_global: "Révisions de l'historique des documents activées si activées globalement",
    doc_history_enabled: "Révisions de l'historique des documents ACTIVÉES",
    doc_history_not_enabled: "Révisions de l'historique des documents NON activées",
    doc_history_description: "Lorsqu'il est activé, chaque document de cette collection conservera un historique des modifications. Ceci est utile à des fins d'audit. Les données sont stockées dans une sous-collection du document dans votre base de données, appelée __history.",
    document_id_generation: "Génération des ID de document",
    code_defined: "Défini par le code",
    users_must_define_id: "Les utilisateurs doivent définir un ID",
    users_can_define_id: "Les utilisateurs peuvent définir un ID, mais ce n'est pas obligatoire",
    doc_id_auto_generated: "L'ID du document est généré automatiquement",
    config_doc_id_generation: "Configurez comment les ID de document sont générés lors de la création de nouvelles entités.",
    enable_text_search: "Activer la recherche de texte pour cette collection",
    text_search_description: "Autoriser la recherche de texte pour cette collection. Si vous n'avez pas spécifié de délégué de recherche de texte, la recherche de texte locale intégrée sera utilisée. Ceci n'est pas recommandé pour les grandes collections, car cela peut entraîner des problèmes de performances et de coûts.",
    database_id: "ID de base de données",
    default_text: "(par défaut)",

    custom_actions: "Actions personnalisées",
    more_info: "Plus d'informations",
    define_custom_actions_cli: "Définissez vos propres actions personnalisées en les téléchargeant via la CLI.",
    action_defined_in_code: "Cette action est définie dans le code avec la clé",
    add_custom_entity_action: "Ajouter une action d'entité personnalisée",
    remove_this_action: "Supprimer cette action ?",
    remove_action_warning: "Cela ne supprimera aucune donnée, uniquement l'action dans le panneau d'administration",

    subcollections_of: "Sous-collections de",
    add_subcollection: "Ajouter une sous-collection",
    custom_views: "Vues personnalisées",
    define_custom_views_cli: "Définissez vos propres vues personnalisées en les téléchargeant via la CLI.",
    view_defined_in_code: "Cette vue est définie dans le code avec la clé",
    add_custom_entity_view: "Ajouter une vue d'entité personnalisée",
    delete_this_subcollection: "Supprimer cette sous-collection ?",
    remove_collection_warning: "Cela ne supprimera aucune donnée, uniquement la collection dans le panneau d'administration",
    remove_this_view: "Supprimer cette vue ?",
    remove_view_warning: "Cela ne supprimera aucune donnée, uniquement la vue dans le panneau d'administration",

    no_collection_selected: "Aucune collection sélectionnée",
    code_for_collection: "Code pour",
    use_config_define_json: "Utilisez cette configuration pour définir la collection au format JSON.",
    customise_collection_code: "Si vous souhaitez personnaliser la collection dans le code, vous pouvez ajouter ce code de collection à la configuration de votre application d'administration.",
    copied: "Copié",

    property_cant_be_edited: "Cette propriété ne peut pas être modifiée",
    property_not_editable_description: "Vous n'avez peut-être pas l'autorisation de la modifier ou elle est définie dans le code et ne peut pas être modifiée.",
    delete_this_property: "Supprimer cette propriété ?",
    delete_property_warning: "Cela ne supprimera aucune donnée, mais modifiera uniquement la collection.",
    error_must_specify_id: "Vous devez spécifier un ID pour le champ",
    error_id_format: "L'ID ne peut contenir que des lettres, des chiffres et des traits de soulignement (_), et ne doit pas commencer par un chiffre",
    error_id_already_exists: "Il existe déjà un autre champ avec cet ID",
    error_must_specify_title: "Vous devez spécifier un titre pour le champ",
    custom_or_other: "Personnalisé/Autre",
    select_property_widget: "Sélectionnez un widget de propriété",
    error_changing_data_type: "Ce widget utilise un type de données différent de celui initialement sélectionné. Cela peut provoquer des erreurs avec les données existantes.",
    required: "Requis",

    enum_form_dialog: "Boîte de dialogue du formulaire Enum",
    imported_data_preview: "Aperçu des données importées",
    entities_with_same_id_overwritten: "Les entités avec le même identifiant seront écrasées",
    collection_editor: "Éditeur de collection",
    properties_in_this_group: "Propriétés de ce groupe",
    data_property_mapping: "Mappage de propriétés de données",
    property_edit_view: "Vue d'édition de propriété",
    all_of_these: "Tous ces éléments",
    any_of_these: "N'importe lequel de ces éléments",

    only_admins_edit_roles: "Seuls les administrateurs peuvent modifier les rôles",
    error_user_not_found: "Utilisateur introuvable",
    all_roles: "Tous les rôles",
    role: "Rôle",
    name_of_this_role: "Nom de ce rôle",
    id_of_this_role: "ID de ce rôle",
    create_entities: "Créer des entités",
    read_entities: "Lire des entités",
    update_entities: "Mettre à jour des entités",
    delete_entities: "Supprimer des entités",
    all_collections: "Toutes les collections",
    create_entities_in_collections: "Créer des entités dans les collections",
    access_all_data_in_every_collection: "Accéder à toutes les données de chaque collection",
    update_data_in_any_collection: "Mettre à jour les données dans n'importe quelle collection",
    delete_data_in_any_collection: "Supprimer des données dans n'importe quelle collection",
    allow_all_permissions_in_this_collections: "Autoriser toutes les autorisations dans ces collections",
    all: "Tout",
    customise_permissions_description: "Vous pouvez personnaliser les autorisations que les utilisateurs liés à ce rôle peuvent exécuter dans les entités de chaque collection",
    create_collections: "Créer des collections",
    yes: "Oui",
    no: "Non",
    can_user_create_collections: "L'utilisateur peut-il créer des collections",
    edit_collections: "Modifier les collections",
    only_own_collections: "Uniquement les siennes",
    own: "Propre",
    can_user_edit_collections: "L'utilisateur peut-il modifier les collections",
    delete_collections: "Supprimer les collections",
    can_user_delete_collections: "L'utilisateur peut-il supprimer des collections",
    error_saving_role: "Une erreur s'est produite lors de l'enregistrement de ce rôle",
    create_role: "Créer un rôle",
    update: "Mettre à jour",

    only_admins_change_roles: "Seuls les administrateurs peuvent modifier les rôles",
    must_be_at_least_one_admin: "Il doit y avoir au moins un administrateur",
    logged_user_not_found: "Utilisateur connecté introuvable",
    user: "Utilisateur",
    user_id: "ID de l'utilisateur",
    name_of_this_user: "Nom de cet utilisateur",
    email_of_this_user: "Email de cet utilisateur",
    roles: "Rôles",
    create_user: "Créer un utilisateur",

    users: "Utilisateurs",
    add_user: "Ajouter un utilisateur",
    add_role: "Ajouter un rôle",
    is_admin: "Est Admin",
    default_permissions: "Autorisations par défaut",
    created_on: "Créé le",
    email: "E-mail",
    id: "ID",
    read: "Lire",

    column_in_file: "Colonne dans le fichier",
    map_to_property: "Mappage à la propriété",
    default_values: "Valeurs par défaut",
    default_values_description: "Vous pouvez sélectionner une valeur par défaut pour les colonnes non mappées et les valeurs vides :",
    property: "Propriété",
    default_value: "Valeur par défaut",
    autogenerate_id: "Générer automatiquement l'ID",
    id_column_description: "Colonne qui sera utilisée comme ID pour chaque document",
    do_not_set_value: "Ne pas définir de valeur",
    set_value_to_true: "Définir la valeur sur Vrai (true)",
    set_value_to_false: "Définir la valeur sur Faux (false)",
    drag_and_drop_file: "Glissez et déposez un fichier ici ou cliquez pour télécharger",
    error_saving_data: "Erreur lors de l'enregistrement des données",
    retry: "Réessayer",
    saving_data: "Enregistrement des données",
    entities_saved: "entités enregistrées",
    do_not_close_tab: "Ne fermez pas cet onglet, sinon l'importation sera interrompue",
    import: "Importer",
    import_data: "Importer des données",
    upload_file_description: "Téléchargez un fichier CSV, Excel ou JSON et mappez-le à votre schéma existant",
    back: "Retour",
    next: "Suivant",
    save_data: "Enregistrer les données",
    use_column_as_id: "Utiliser cette colonne comme ID",
    do_not_import_property: "Ne pas importer cette propriété",
    entities_will_be_overwritten: "Les entités avec le même identifiant seront écrasées",
    data_imported_successfully: "Données importées avec succès",
    export: "Exporter",
    export_data: "Exporter des données",
    download_table_csv: "Télécharger le contenu de cette table au format CSV",
    csv: "CSV",
    json: "JSON",
    dates_as_timestamps: "Dates sous forme d'horodatages",
    dates_as_strings: "Dates sous forme de chaînes",
    flatten_arrays: "Aplatir les tableaux",
    download: "Télécharger",
    large_number_of_documents: "Cette collection contient un grand nombre de documents ({{count}}).",
    too_many_documents_to_export: "Cette collection contient plus de documents ({{count}}) que le navigateur ne peut en exporter dans un seul fichier (limite {{limit}}). Filtrez-la avant d'exporter.",
    include_undefined_values: "Inclure les valeurs non définies",
    submit: "Soumettre",

    no_filterable_properties: "Aucune propriété filtrable disponible",
    apply_filters: "Appliquer les filtres",

    // ─── Filter Presets ──────────────────────────────────────────
    filter_presets: "Préréglages",
    filter_preset_apply: "Appliquer le préréglage",
    filter_preset_active: "Actif : {{label}}",

    list: "Liste",
    table_view_mode: "Tableau",
    cards: "Cartes",
    board: "Tableau",
    initialize_kanban_order_desc: "Ceci attribuera des valeurs d'ordre séquentiel à tous les éléments qui n'en ont pas. Les articles conserveront leur ordre actuel dans chaque colonne.",
    kanban_view_not_available: "La vue Kanban n'est pas disponible",
    kanban_view_requires_enum: "La vue Kanban requiert une propriété de chaîne de caractères avec des valeurs Enumération (enum) pour regrouper les entités en colonnes. Veuillez ajouter une propriété Enum à votre schéma de collection pour utiliser cette vue.",
    no_enum_values_configured: "Aucune valeur enum configurée pour la propriété \"{{property}}\"",
    items_need_backfill: "Certains éléments n'ont pas de valeurs d'ordre. Initialisez-les pour permettre la réorganisation par glisser-déposer.",
    kanban_order_not_configured: "L'ordonnancement par glisser-déposer n'est pas configuré. Définissez une propriété d'ordre dans les paramètres de la collection pour conserver les positions des cartes.",
    initialize: "Initialiser",
    confirm_multiple_delete: "Confirmez la suppression multiple ?",
    delete_entity_confirm_title: "Souhaitez-vous supprimer {{entityName}} ?",
    add_existing: "Ajouter un existant",
    unlink_entity_confirm_title: "Retirer ce/cette {{entityName}} de cet enregistrement ?",
    unlink_entity_confirm_body: "Il reste dans {{collectionName}} et disponible pour d'autres enregistrements.",
    confirm_multiple_unlink: "les retirer de cet enregistrement ?",
    no_filter: "Aucun filtre",
    is_true: "est vrai",
    is_false: "est faux",
    error_uploading_file_size: "Erreur lors de l'envoi : le fichier dépasse {{maxSize}} octets",
    error_uploading_file_type: "Erreur lors de l'envoi : ce type de fichier n'est pas pris en charge",
    drag_drop_files: "Glissez-déposez des fichiers ici, ou cliquez pour les modifier",
    drag_drop_file: "Glissez-déposez un fichier ici, ou cliquez pour le modifier",
    multiple_deleted: "Suppression multiple terminée",
    some_entities_deleted: "Certaines des entités ont été supprimées, mais pas toutes",
    error_deleting_entities: "Erreur lors de la suppression des entités",
    deleted: "supprimé",
    selection_options: "Options de sélection",
    selection_menu_all_loaded: "Tout sur cette page",
    selection_menu_all_matching: "Les {{total}} {{collection}}",
    selection_menu_none: "Aucun",
    selection_select_all_loaded: "Sélectionner les lignes chargées",
    selection_deselect_all: "Tout désélectionner",
    selection_reading_rows: "Lecture des lignes… {{loaded}} sur {{total}}",
    selection_reading_rows_unknown: "Lecture des lignes… {{loaded}} jusqu’à présent",
    selection_deleting_progress: "{{completed}} supprimés sur {{total}}",
    confirm_delete_selection: "Supprimer {{total}} {{collection}} ?",
    confirm_delete_selection_unknown: "Supprimer toutes les lignes correspondant au filtre actuel ?",
    confirm_delete_selection_body: "Cette action est irréversible. Chaque ligne est supprimée séparément, l’opération peut donc prendre du temps.",

    export_selection_count: "Télécharger les {{total}} lignes sélectionnées au format {{format}}",
    export_selection_all_matching: "Télécharger tous les {{collection}} correspondant au filtre actuel",

    select_reference: "Sélectionner une référence",
    select_references: "Sélectionner des références",
    account_settings: "Paramètres du compte",
    profile: "Profile",
    security: "Sécurité",
    sessions: "Sessions",
    change_password: "Changer le mot de passe",
    current_password: "Mot de passe actuel",
    new_password: "Nouveau mot de passe",
    confirm_password: "Confirmer le nouveau mot de passe",
    password_changed: "Mot de passe modifié. Vous allez être déconnecté.",
    passwords_dont_match: "Les mots de passe ne correspondent pas",
    password_too_short: "Le mot de passe doit comporter au moins 8 caractères",
    password_change_not_available: "Le changement de mot de passe n'est pas disponible pour les comptes utilisant un fournisseur de connexion externe.",
    changing_password: "Modification…",
    display_name: "Nom affiché",
    photo_url: "URL de la photo",
    save_profile: "Enregistrer le profil",
    saving: "Saving...",
    no_active_sessions: "Aucune session active trouvée.",
    revoking: "Revoking...",
    revoke_all_sessions: "Révoquer toutes les sessions",
    unknown_device: "Appareil inconnu",
    current: "Current",
    role_id: "ID du rôle",
    role_name: "Nom du rôle",
    add_reference: "Ajouter une référence",
    add_reference_to: "Ajouter une référence à {{name}}",

    /** RolesView — table & permissions */
    role_deleted_successfully: "Rôle supprimé",
    error_deleting_role: "Erreur lors de la suppression du rôle",
    collection_permissions: "Permissions de la collection",
    collection: "Collection",
    no_collections_configured: "Aucune collection configurée",
    no_security_rules_defined: "Aucune règle de sécurité définie — toutes les opérations sont autorisées",
    no_rules: "aucune règle",

    /** UsersView — snackbar */
    bootstrap_admin_success: "Vous êtes désormais administrateur ! Actualisation…",
    failed_to_bootstrap_admin: "Impossible de créer l'administrateur initial",
    user_deleted_successfully: "Utilisateur supprimé",
    error_deleting_user: "Erreur lors de la suppression de l'utilisateur",
    user_created_successfully: "Utilisateur créé",
    invitation_sent: "Un e-mail d'invitation a été envoyé à {{email}}. Le lien permet de définir le mot de passe.",
    invitation_sent_title: "Invitation envoyée",
    temporary_password: "Mot de passe temporaire",
    temporary_password_description: "L'e-mail n'est pas configuré. Transmettez ce mot de passe temporaire à l'utilisateur de manière sécurisée. Il ne sera plus affiché.",
    temporary_password_email_failed_description: "L'e-mail n'a pas pu être remis. Transmettez ce mot de passe temporaire à l'utilisateur de manière sécurisée. Il ne sera plus affiché.",
    copy_password: "Copier le mot de passe",
    password_copied: "Mot de passe copié dans le presse-papiers",

    /** UsersView — pagination & search */
    search_users: "Rechercher des utilisateurs",
    created: "Créé le",
    actions: "Actions",
    no_users_found: "Aucun utilisateur trouvé",
    reset_password: "Réinitialiser le mot de passe",
    reset_password_success: "Mot de passe réinitialisé",
    reset_password_confirmation: "Voulez-vous vraiment réinitialiser le mot de passe de cet utilisateur ?",
    reset_password_send_email: "Envoyer un e-mail de réinitialisation",
    reset_password_set_manually: "Définir un mot de passe manuellement",
    reset_password_set_manually_description: "Le mot de passe est mis à jour immédiatement et aucun e-mail n'est envoyé. Transmettez-le à l'utilisateur de manière sécurisée.",

    /** Permission-denied empty states */
    no_permission_to_view_users: "Vous n'avez pas la permission de voir les utilisateurs",
    no_permission_to_view_roles: "Vous n'avez pas la permission de voir les rôles",
    no_permission_description: "Contactez un administrateur si vous avez besoin d'accéder à cette section.",
    error_resetting_password: "Erreur lors de la réinitialisation du mot de passe",

    /** Editor table-bubble */
    add_row_before: "Insérer une ligne avant",
    add_row_after: "Insérer une ligne après",
    delete_row: "Supprimer la ligne",
    add_column_before: "Insérer une colonne avant",
    add_column_after: "Insérer une colonne après",
    delete_column: "Supprimer la colonne",
    delete_table: "Supprimer le tableau",

    /** Editor image-bubble */
    alt_text: "Texte alternatif",
    title: "Title",

    /** MapFieldBinding */
    a_property_of_this_map_has_error: "Une propriété de cette table d'association contient une erreur",

    /** AI Collection Generator Popover */
    generate_collection_with_ai: "Générer une collection avec l'IA",
    modify_collection_with_ai: "Modifier la collection avec l'IA",
    describe_collection_to_create: "Décrivez la collection que vous souhaitez créer.",
    describe_changes_to_make: "Décrivez les modifications que vous souhaitez apporter à cette collection.",
    ai_placeholder_create: "ex. : Créer une collection de produits avec nom, prix, description et catégorie...",
    ai_placeholder_modify: "ex. : Ajouter un champ d'image miniature avec stockage, rendre le prix obligatoire...",
    ai_assist: "Assistance IA",
    generating: "Génération en cours...",

    /** Recently extracted strings for collection editor */
    this_is_subcollection_of: "Ceci est une sous-collection de",
    use_existing_paths_database: "Utiliser l'un des chemins existants dans votre base de données :",
    describe_collection_ai: "Décrivez votre collection à l'IA :",
    generate_with_ai: "Générer avec l'IA",
    create_from_json_config: "Créer à partir d'une configuration JSON :",
    paste_json_config: "Coller la configuration JSON",
    create_collection_from_file_formats: "Créer une collection à partir d'un fichier (csv, json, xls, xslx...)",
    select_template: "Sélectionner un modèle :",
    products: "Produits",
    collection_products_subtitle: "Une collection de produits avec images, prix et stock",
    collection_users_subtitle: "Une collection d'utilisateurs avec e-mails, noms et rôles",
    blog_posts: "Articles de blog",
    collection_blog_posts_subtitle: "Une collection d'articles de blog avec images, auteurs et contenu complexe",
    pages: "Pages",
    collection_pages_subtitle: "Une collection de pages avec images, auteurs et contenu complexe",
    continue_from_scratch: "Continuer à partir de zéro",

    /** Admin views config */
    admin_users: "Utilisateurs du panneau d'administration",
    roles_menu: "Rôles",
    project_settings: "Paramètres du projet",

    by_signing_in_you_agree_to_our: "En vous connectant, vous acceptez nos",
    terms_and_conditions: "Conditions générales",
    and_our: "et notre",
    privacy_policy: "Politique de confidentialité",
    email_password: "E-mail/Mot de passe",
    sign_in_with_google: "Se connecter avec Google",

    // --- Auth error messages ---
    auth_user_not_found: "Utilisateur non trouvé",
    auth_wrong_password: "Mot de passe erroné. Veuillez réessayer.",
    auth_user_disabled: "Utilisateur désactivé. Veuillez contacter le support.",
    auth_account_exists_with_different_credential: "Un compte existe avec une méthode de connexion différente",
    auth_email_already_in_use: "L'e-mail est déjà utilisé",
    auth_google_permissions_required: "Vous devez accorder des autorisations supplémentaires afin de gérer vos projets Google Cloud",
    auth_invalid_email_password: "Veuillez entrer l'e-mail et le mot de passe",
    auth_enter_email_first: "Veuillez d'abord entrer votre e-mail",
    auth_password_reset_sent: "E-mail de réinitialisation du mot de passe envoyé",
    auth_sign_in_account: "Connectez-vous à votre compte",
    auth_create_new_account: "Créer un nouveau compte",
    auth_password: "Mot de passe",
    auth_reset_password: "Réinitialiser le mot de passe",
    auth_new_user: "Nouvel utilisateur ?",
    auth_have_account: "Vous avez déjà un compte ?",
    auth_sign_in: "Se connecter",
    auth_sign_up: "S'inscrire",


    auto_setup_collections_button: "Configurer les collections automatiquement",
    auto_setup_collections_title: "Configurer les collections automatiquement ?",
    auto_setup_collections_desc: "Cela créera automatiquement des configurations de collection pour les collections qui ne sont <b>PAS</b> déjà mappées",
    this_can_take_a_minute: "Cela peut prendre une minute",
    no_collections_found_to_setup: "Aucune collection à configurer trouvée",
    collections_have_been_setup: "Les collections ont été configurées",
    error_setting_up_collections: "Erreur lors de la configuration des collections",

    // --- Home Suggestions ---

    admin_panel_ready_bring_data: "Votre panneau d'administration est prêt. Ajoutons vos données.",
    admin_panel_ready_get_started: "Votre panneau d'administration est prêt. Voici comment démarrer.",
    auto_detect_collections: "Détecter automatiquement les collections",
    auto_detect_collections_desc: "Laissez l'IA analyser votre base de données et générer automatiquement des schémas de collection.",
    create_a_collection: "Créer une collection",
    create_collection_desc: "Définissez manuellement votre première collection à partir de zéro à l'aide de l'éditeur visuel.",
    read_the_docs: "Lire la documentation",
    read_the_docs_desc: "Apprenez à personnaliser les champs, les vues, les actions et bien plus encore.",
    explore_docs: "Explorer la documentation",
    want_to_customize_with_code: "Vous souhaitez personnaliser avec du code ? Exécutez",
    to_scaffold_a_local_project: "pour générer un projet local.",

    // ─── Collection Editor — Validation ──────────────────────────
    validation: "Validation",
    unique: "Unique",
    required_message: "Message de champ obligatoire",
    required_tooltip: "Vous ne pourrez pas enregistrer cette entité si cette valeur n'est pas définie",
    unique_tooltip: "Il ne peut pas y avoir plusieurs entités avec la même valeur",
    lowercase: "Minuscules",
    uppercase: "Majuscules",
    trim: "Supprimer les espaces",
    exact_length: "Longueur exacte",
    min_length: "Longueur min.",
    max_length: "Longueur max.",
    matches_regex: "Correspond à une regex",
    not_valid_regexp: "Expression régulière non valide",
    regex_helper: "ex. /^\\d+$/ pour les chiffres uniquement",
    min_value: "Valeur min.",
    max_value: "Valeur max.",
    less_than: "Inférieur à",
    more_than: "Supérieur à",
    positive_value: "Valeur positive",
    negative_value: "Valeur négative",
    integer_value: "Valeur entière",

    // ─── Collection Editor — Property Edit ───────────────────────
    invalid_regular_expression: "Expression régulière non valide",
    must_specify_target_collection: "Vous devez spécifier une collection cible pour le champ",
    need_specify_repeat_field: "Vous devez spécifier un champ de répétition",
    need_specify_block_properties: "Vous devez spécifier les propriétés de ce bloc",
    incomplete_condition: "Condition incomplète - veuillez sélectionner un champ",
    field_name: "Nom du champ",

    // ─── Collection Editor — Display & Config ────────────────────
    kanban_column_property: "Propriété de colonne Kanban",
    select_a_property: "Sélectionner une propriété",
    kanban_property_not_found: "La propriété \"{{property}}\" n'existe pas ou n'est pas une propriété de type string avec enum. Veuillez sélectionner une propriété valide ou effacer la sélection.",
    no_enum_string_properties: "Aucune propriété de type string avec enum trouvée. Ajoutez une propriété string avec enumValues pour utiliser la vue Kanban.",
    kanban_column_description: "Sélectionnez une propriété de type string avec des valeurs enum pour regrouper les entités en colonnes",
    create_property: "+ Créer la propriété \"{{property}}\"",
    order_property: "Propriété d'ordre",
    order_property_not_found: "La propriété \"{{property}}\" n'existe pas ou n'est pas une propriété numérique. Veuillez sélectionner une propriété valide ou effacer la sélection.",
    no_number_properties: "Aucune propriété numérique trouvée. Ajoutez une propriété numérique pour activer le tri.",
    order_property_description: "Sélectionnez une propriété numérique pour conserver l'ordre des éléments",
    display_settings: "Paramètres d'affichage",
    default_row_size: "Taille de ligne par défaut",
    side_dialog_width: "Largeur du dialogue latéral",
    side_dialog_width_description: "Définissez optionnellement la largeur (en pixels) du dialogue latéral des entités. La valeur par défaut est 768px",
    inline_editing_enabled: "Les données peuvent être modifiées directement dans la vue tableau",
    inline_editing_disabled: "Les données ne peuvent être modifiées que dans la vue formulaire",
    inline_editing_description: "Autoriser la modification des données directement dans la vue tableau, sans ouvrir la vue formulaire.",
    include_json_view: "Inclure la vue JSON",
    no_json_view: "Ne pas inclure la vue JSON",
    json_view_description: "Inclure la représentation JSON du document.",
    not_found_suffix: "introuvable",

    // ─── Editor ─────────────────────────────────────────────────
    editor_text: "Texte",
    editor_text_description: "Commencez simplement à taper du texte brut.",
    editor_heading_1: "Titre 1",
    editor_heading_1_description: "Grand titre de section.",
    editor_heading_2: "Titre 2",
    editor_heading_2_description: "Titre de section moyen.",
    editor_heading_3: "Titre 3",
    editor_heading_3_description: "Petit titre de section.",
    editor_todo_list: "Liste de tâches",
    editor_todo_list_description: "Suivez les tâches avec une liste de tâches.",
    editor_bullet_list: "Liste à puces",
    editor_bullet_list_description: "Créez une simple liste à puces.",
    editor_numbered_list: "Liste numérotée",
    editor_numbered_list_description: "Créez une liste avec numérotation.",
    editor_quote: "Citation",
    editor_quote_description: "Capturez une citation.",
    editor_code: "Code",
    editor_code_description: "Capturez un extrait de code.",
    editor_image: "Image",
    editor_image_description: "Téléchargez une image depuis votre ordinateur.",
    editor_multiple: "Multiple",
    editor_link: "Lien",
    editor_save: "Enregistrer",
    editor_cancel: "Annuler",
    editor_remove_link: "Supprimer le lien",
    editor_paste_or_type_link: "Coller ou taper le lien",
    editor_open_in_new_window: "Ouvrir dans une nouvelle fenêtre",
    editor_bold: "Gras",
    editor_italic: "Italique",
    editor_underline: "Souligné",
    editor_strikethrough: "Barré",
    editor_autocomplete: "Saisie automatique",
    editor_autocomplete_description: "Ajoutez du texte basé sur le contexte.",

    // ─── Text Search Dialog ─────────────────────────────────────
    text_search_dialog_title: "Activer la recherche de texte",
    text_search_local_not_recommended: "La recherche de texte locale n'est pas recommandée pour les grandes collections.",
    text_search_local_fetch_warning: "Notez que l'activation de la recherche de texte locale nécessite de récupérer tous les documents de votre collection et de les stocker dans le navigateur. Cela peut être inefficace pour les grandes collections et entraîner des coûts supplémentaires.",
    text_search_external_suggestion: "Pour les collections plus grandes, il est recommandé d'utiliser un moteur de recherche externe comme Algolia ou Elastic Search, et d'attribuer un délégué de recherche à votre configuration.",
    text_search_local_description: "La recherche de texte locale est le moyen le plus simple d'activer la recherche de texte dans votre collection. Elle charge tous les documents de la collection dans le navigateur et effectue la recherche localement. C'est l'option recommandée pour les petites collections.",
    text_search_own_implementation: "Vous avez implémenté votre propre contrôleur de recherche de texte. Vous pouvez activer la recherche de texte pour votre collection.",
    text_search_enable_for_collection: "Activer pour cette collection",
    text_search_enable_for_project: "Activer pour le projet",
    text_search_enabled_snackbar: "Recherche de texte locale activée",

    settings_heading: "Paramètres",
    settings_project_name: "Nom du projet",
    settings_default_language: "Langue par défaut",
    settings_default_language_caption: "Sélectionnez la langue de base pour ce projet. Les utilisateurs peuvent modifier cette préférence dans leurs paramètres personnels.",
    settings_enable_local_text_search: "Activer la recherche de texte locale",
    settings_local_text_search_caption: "Activez la recherche de texte locale pour toutes les collections. Cela vous permettra de rechercher des champs textuels à l'aide de la barre de recherche Rebase. Notez que cette fonctionnalité peut entraîner un nombre de lectures plus élevé, car tous les champs textuels de vos collections seront indexés.",
    settings_doc_history_all_collections: "Historique des documents activé pour toutes les collections",
    settings_doc_history_caption: "Lorsque activé, toutes les collections auront l'historique activé par défaut. Vous pouvez modifier ce paramètre pour chaque collection. L'historique sera enregistré dans la sous-collection __history de chaque document.",
    settings_theme: "Thème",
    settings_primary_color: "Couleur primaire",
    settings_secondary_color: "Couleur secondaire",
    settings_sample_theme_components: "Exemples de composants du thème",
    settings_drag_drop_logo: "Glissez-déposez votre logo ici",
    settings_security_rules: "Règles de sécurité",
    settings_security_rules_description: "Rebase utilise les règles de sécurité Firebase pour restreindre l'accès aux données. Lors de la création d'un utilisateur via Rebase, l'attribut personnalisé rebaseUser est ajouté à l'utilisateur dans le projet client. En ajoutant les règles de sécurité suivantes, vous garantissez que les utilisateurs Rebase peuvent accéder aux données via Rebase.",
    settings_security_rules_add_domain: "N'oubliez pas d'ajouter le domaine {{domain}} aux domaines autorisés de votre fournisseur",
    settings_security_rules_caption: "Ces règles restreignent l'accès aux données aux seuls utilisateurs Rebase, mais n'appliquent pas les permissions au niveau de la base de données. Les permissions sont appliquées côté frontend, ce qui convient à la plupart des projets. Si vous devez appliquer les permissions au niveau de la base de données, vous pouvez modifier ces règles de sécurité. Les rôles attribués à un utilisateur sont définis comme attributs personnalisés dans le jeton d'authentification Firebase, vous pouvez donc les utiliser dans vos règles de sécurité.",

    // ─── Studio: SQL Editor ─────────────────────────────────────
    studio_sql_executing_query: "EXÉCUTION DE LA REQUÊTE…",
    studio_sql_query_error: "Erreur de requête",
    studio_sql_run_query_placeholder: "Exécutez une requête pour voir les résultats",
    studio_sql_visual_execution_plan: "Plan d'exécution visuel",
    studio_sql_success: "SUCCESS",
    studio_sql_no_results: "La requête s'est exécutée correctement mais n'a renvoyé aucun résultat.",
    studio_sql_rows: "Rows:",
    studio_sql_time: "Time:",
    studio_sql_copy_markdown: "Copier en Markdown",
    studio_sql_export_json: "Exporter en JSON",
    studio_sql_export_csv: "Exporter en CSV",
    studio_sql_format_sql: "Formater le SQL",
    studio_sql_explain: "Explain",
    studio_sql_limit_1000: "Limit 1000",
    studio_sql_remove_from_favorites: "Retirer des favoris",
    studio_sql_add_to_favorites: "Ajouter aux favoris",
    studio_sql_save: "Save",
    studio_sql_run: "Run",
    studio_sql_database: "Database",
    studio_sql_role: "Role",
    studio_sql_admin: "(Admin)",
    studio_sql_select_db: "Choisir la base",
    studio_sql_query_results: "Résultats de la requête",
    studio_sql_save_snippet: "Enregistrer l'extrait SQL",
    studio_sql_snippet_name: "Nom de l'extrait",
    studio_sql_snippet_name_placeholder: "p. ex. Récupérer tous les utilisateurs",
    studio_sql_snippet_saved_local: "Cet extrait sera enregistré dans votre stockage local.",
    studio_sql_cancel: "Cancel",
    studio_sql_dangerous_operation: "Opération dangereuse détectée",
    studio_sql_dangerous_operation_body: "La requête que vous allez exécuter contient des opérations potentiellement destructrices (DELETE, DROP, TRUNCATE ou UPDATE sans WHERE). Voulez-vous vraiment continuer ?",
    studio_sql_snippet_saved: "Extrait « {{name}} » enregistré.",
    studio_sql_markdown_copied: "Résultats copiés en Markdown !",
    studio_sql_markdown_copy_failed: "Impossible de copier le Markdown dans le presse-papiers.",
    studio_sql_row_updated: "Ligne mise à jour.",
    studio_sql_cannot_edit_missing_query: "Impossible de modifier les lignes : la requête sous-jacente est absente.",
    studio_sql_cannot_resolve_table: "Impossible de déterminer la table ou la clé primaire",
    studio_sql_missing_pk: "La ligne n'a pas les colonnes de clé primaire : {{columns}}. Mise à jour impossible en toute sécurité.",
    studio_sql_update_failed: "Échec de la mise à jour : {{message}}",
    studio_sql_execution_not_supported: "La source de données actuelle ne prend pas en charge l'exécution de SQL.",
    studio_sql_error_executing: "Une erreur s'est produite lors de l'exécution de la requête.",
    studio_sql_error_explaining: "Une erreur s'est produite lors de l'analyse de la requête.",
    studio_sql_save_first_to_favorite: "Enregistrez l'extrait avant de l'ajouter aux favoris.",
    studio_sql_collections_label: "Collections:",
    studio_sql_admin_collections_tooltip: "Tables in this query that are mapped as admin collections",
    studio_sql_edit_entity: "Edit {{name}} #{{id}}",
    studio_sql_sql_not_supported: "Cette source de données ne prend pas en charge l'exécution de SQL",
    studio_sql_fetch_error: "Impossible de récupérer les options de connexion : {{message}}",
    studio_sql_unexpected_format: "Format de données inattendu : {{type}}",
    studio_sql_no_tables: "Aucune table trouvée dans cette base de données.",
    studio_sql_schema_fetch_error: "Impossible de récupérer le schéma : {{message}}",

    // ─── Studio: SQL Editor Sidebar ──────────────────────────────
    studio_sql_sidebar_snippets: "Snippets",
    studio_sql_sidebar_history: "History",
    studio_sql_sidebar_schema: "Schema",
    studio_sql_sidebar_no_snippets: "Aucun extrait enregistré",
    studio_sql_sidebar_save_snippet_hint: "Enregistrez une requête pour la retrouver ici.",
    studio_sql_sidebar_no_history: "Aucun historique",
    studio_sql_sidebar_history_hint: "Les requêtes exécutées apparaîtront ici.",
    studio_sql_sidebar_delete_snippet: "Supprimer l'extrait",
    studio_sql_close_tab: "Fermer cet onglet de requête",
    studio_sql_new_tab: "Nouvel onglet de requête",

    // ─── Studio: Schema Browser ──────────────────────────────────
    studio_schema_tables: "Tables",
    studio_schema_loading: "Chargement du schéma…",
    studio_schema_no_tables: "Aucune table trouvée",
    studio_schema_retry: "Retry",
    studio_schema_primary_key: "Clé primaire",
    studio_schema_select_all: "SELECT * FROM",
    studio_schema_insert_into: "INSERT INTO",
    studio_schema_update: "UPDATE",
    studio_schema_delete_from: "DELETE FROM",
    studio_schema_columns: "{{count}} colonnes",

    // ─── Studio: RLS Editor ──────────────────────────────────────
    studio_rls_title: "Sécurité au niveau des lignes",
    studio_rls_description: "Gérez les politiques RLS de vos tables",
    studio_rls_enabled: "RLS activée",
    studio_rls_disabled: "RLS désactivée",
    studio_rls_no_rls: "Sans RLS",
    studio_rls_enable_rls: "Activer la RLS",
    studio_rls_disable_rls: "Désactiver la RLS",
    studio_rls_create_policy: "Créer une politique",
    studio_rls_policies: "Policies",
    studio_rls_no_policies: "Aucune politique définie",
    studio_rls_no_policies_desc: "Cette table n'a aucune politique RLS. L'accès à toutes les lignes dépend de l'état de la RLS.",
    studio_rls_add_first_policy: "Ajouter votre première politique",
    studio_rls_force_rls: "Forcer la RLS",
    studio_rls_force_rls_desc: "Une fois activé, les politiques RLS s'appliquent aussi au propriétaire de la table.",
    studio_rls_enable_force_rls: "Activer la RLS forcée",
    studio_rls_disable_force_rls: "Désactiver la RLS forcée",
    studio_rls_edit: "Edit",
    studio_rls_delete: "Delete",
    studio_rls_confirm_delete_title: "Supprimer la politique",
    studio_rls_confirm_delete_body: "Voulez-vous vraiment supprimer cette politique ? Cette action est irréversible.",
    studio_rls_confirm_enable_title: "Activer la sécurité au niveau des lignes",
    studio_rls_confirm_enable_body: "Activer la RLS restreindra l'accès aux lignes de cette table selon vos politiques. Assurez-vous d'avoir des politiques appropriées.",
    studio_rls_confirm_disable_title: "Désactiver la sécurité au niveau des lignes",
    studio_rls_confirm_disable_body: "Désactiver la RLS rendra toutes les lignes accessibles à tous les rôles. Voulez-vous vraiment continuer ?",
    studio_rls_select_table: "Sélectionnez une table",
    studio_rls_no_tables: "Aucune table disponible",
    studio_rls_error: "Erreur lors du chargement des politiques",
    studio_rls_retry: "Retry",
    studio_rls_loading: "Chargement des politiques…",

    // ─── Studio: Policy Editor ───────────────────────────────────
    studio_policy_edit: "Modifier la politique",
    studio_policy_create: "Créer une nouvelle politique",
    studio_policy_defining_rules: "Définition des règles d'accès pour",
    studio_policy_cancel: "Cancel",
    studio_policy_save: "Enregistrer la politique",
    studio_policy_template: "Partir d'un modèle (facultatif)",
    studio_policy_select_template: "Sélectionnez un modèle…",
    studio_policy_name: "Nom de la politique",
    studio_policy_name_placeholder: "Donnez à votre politique un nom explicite",
    studio_policy_behavior: "Comportement de la politique",
    studio_policy_permissive: "Permissive",
    studio_policy_permissive_desc: "Combinée avec « OR »",
    studio_policy_restrictive: "Restrictive",
    studio_policy_restrictive_desc: "Combinée avec « AND »",
    studio_policy_command: "Commande de la politique",
    studio_policy_target_roles: "Rôles ciblés",
    studio_policy_roles_placeholder: "Sélectionnez des rôles (public par défaut)",
    studio_policy_using_expr: "Expression USING",
    studio_policy_using_expr_desc: "S'applique aux lignes existantes (SELECT, UPDATE, DELETE)",
    studio_policy_check_expr: "Expression WITH CHECK",
    studio_policy_check_expr_desc: "S'applique aux lignes nouvelles ou modifiées (INSERT, UPDATE)",
    studio_policy_help_title: "Guide de la sécurité au niveau des lignes (RLS)",
    studio_policy_help_intro: "La sécurité au niveau des lignes (RLS) permet de restreindre les lignes qu'un utilisateur peut consulter ou modifier selon son état d'authentification ou ses rôles.",
    studio_policy_help_step1_title: "1. Sélectionnez un modèle",
    studio_policy_help_step1_desc: "Si vous débutez avec la RLS, le plus simple est de choisir un modèle prédéfini dans la liste. Il configure automatiquement la politique pour des cas courants comme « les utilisateurs peuvent modifier leurs propres lignes ».",
    studio_policy_help_step2_title: "2. Rôles ciblés",
    studio_policy_help_step2_desc: "Choisissez les utilisateurs auxquels la politique s'applique :",
    studio_policy_help_role_public: "S'applique à tout le monde (connecté ou non).",
    studio_policy_help_role_authenticated: "S'applique uniquement aux utilisateurs connectés.",
    studio_policy_help_role_anon: "S'applique uniquement aux utilisateurs qui NE SONT PAS connectés.",
    studio_policy_help_step3_title: "3. Expression USING",
    studio_policy_help_step3_desc: "Une condition SQL qui doit être vraie pour que les lignes existantes soient visibles ou modifiables (SELECT, UPDATE, DELETE).",
    studio_policy_help_step3_example: "Garantit que les utilisateurs ne voient que les lignes dont ils sont propriétaires.",
    studio_policy_help_step4_title: "4. Expression WITH CHECK",
    studio_policy_help_step4_desc: "Une condition SQL qui doit être vraie pour que les lignes nouvelles ou modifiées soient enregistrées (INSERT, UPDATE).",
    studio_policy_help_step4_example: "Généralement identique à l'expression USING lorsque les utilisateurs ne peuvent insérer ou modifier que leurs propres données.",
    studio_policy_help_auth_vars_title: "Variables d'authentification Rebase",
    studio_policy_help_auth_vars_desc: "Rebase fournit des fonctions natives que vous pouvez utiliser dans vos expressions :",
    studio_policy_help_auth_uid: "Renvoie l'identifiant de l'utilisateur courant sous forme de texte. Exemple :",
    studio_policy_help_auth_jwt: "Renvoie l'intégralité de la charge utile du JWT en JSONB, ce qui permet de vérifier des revendications personnalisées. Exemple :",
    studio_policy_help_auth_roles: "Renvoie les identifiants de rôle de l'utilisateur sous forme de chaîne séparée par des virgules. À utiliser de préférence avec :",
    studio_policy_help_docs_cta: "Pour en savoir plus sur les politiques Postgres, consultez la documentation officielle.",
    studio_policy_help_read_docs: "Lire la documentation",
    studio_policy_help_got_it: "J'ai compris !",

    // ─── Studio: UI Actions ──────────────────────────────────────
    studio_add_kanban_column: "Ajouter une colonne",
    studio_add_kanban_column_title: "Ajouter une colonne Kanban",
    studio_add_kanban_column_name: "Nom de la colonne",
    studio_add_kanban_column_name_placeholder: "Nom de la nouvelle colonne",
    studio_add_kanban_column_add: "Add",
    studio_add_kanban_column_cancel: "Cancel",
    studio_collection_view_sql: "Éditeur SQL",
    studio_collection_view_admin: "Vue d'administration",
    studio_editor_collection_tooltip: "Modifier le schéma de la collection",
    studio_editor_collection_no_permission: "Vous n'avez pas la permission de modifier cette collection",
    studio_editor_collection_start_tooltip: "Copier le chemin ou modifier le schéma",
    studio_editor_collection_start_no_permission: "Vous n'avez pas la permission de modifier cette collection",
    studio_editor_collection_start_copied: "Copied!",
    studio_editor_entity_tooltip: "Modifier le schéma de l'entité",
    studio_editor_entity_no_permission: "Vous n'avez pas la permission de modifier cette entité",
    studio_home_edit_collection: "Modifier la collection",
    studio_home_delete_collection: "Supprimer la collection",
    studio_home_confirm_delete_title: "Supprimer la collection ?",
    studio_home_confirm_delete_body: "Voulez-vous vraiment supprimer la collection « {{name}} » ? Cette action est irréversible.",
    studio_kanban_setup: "Configuration du Kanban",
    studio_missing_reference: "Référence manquante : {{path}}",
    studio_missing_reference_create: "Create",
    studio_new_collection: "Nouvelle collection",
    studio_new_collection_card: "Nouvelle collection",
    studio_new_collection_no_permission: "Vous n'avez pas les permissions pour créer des collections",
    studio_property_add_column: "Ajouter une nouvelle propriété",
    studio_property_add_column_no_permission: "Vous n'avez pas la permission d'ajouter de nouvelles propriétés",
    studio_add_kanban_column_desc: "Ajoute une nouvelle option à la propriété « {{property}} ». Une nouvelle colonne apparaîtra dans le tableau Kanban.",
    studio_add_kanban_column_adding: "Adding...",
    studio_collection_view_edit: "Edit",
    studio_editor_collection_disabled: "La modification des collections est désactivée",
    studio_editor_collection_edit: "Modifier la collection",
    studio_editor_entity_save_first: "Vous devez enregistrer le document avant de modifier le schéma",
    studio_editor_entity_edit_schema: "Modifier le schéma de ce formulaire",
    studio_editor_collection_start_save_filter: "Enregistrer le filtre et le tri par défaut",
    studio_editor_collection_start_clear_filter: "Effacer le filtre et le tri par défaut",
    studio_editor_collection_start_reset_filter: "Rétablir le filtre et le tri par défaut",
    studio_editor_collection_start_saved: "Configuration par défaut enregistrée",
    studio_home_duplicate_collection: "Duplicate",
    studio_home_delete: "Delete",
    studio_home_confirm_delete_no_data: "Aucune donnée ne sera supprimée, seulement la collection dans l'interface d'administration",
    studio_home_collection_deleted: "Collection supprimée",
    studio_kanban_configure: "Configurer le Kanban",
    studio_missing_reference_error: "Aucune collection pour le chemin : {{path}}",
    studio_new_collection_add: "Ajouter une nouvelle collection",

    // ─── Property field labels ──────────────────────────────────
    db_column_type: "Type de colonne de base de données",
    primary_key_unique_id: "Clé primaire / ID unique",
    spread_children_as_columns: "Étendre les enfants en colonnes",
    mode: "Mode",
    timezone: "Fuseau horaire",
    target_collection: "Collection cible",

    // ─── Storage property ───────────────────────────────────────
    storage_file_name: "Nom du fichier",
    storage_path: "Chemin de stockage",
    storage_max_size: "Taille maximale (en octets)",
    storage_resize_mode: "Mode de redimensionnement",
    storage_output_format: "Format de sortie",
    storage_max_width: "Largeur maximale (px)",
    storage_max_height: "Hauteur maximale (px)",
    storage_quality: "Qualité (0-100)",
    storage_file_upload_config: "Configuration de téléchargement de fichier",
    storage_image_resize_config: "Configuration du redimensionnement d'image",
    storage_all_file_types: "Tous les types de fichiers autorisés",
    storage_allowed_file_types: "Types de fichiers autorisés",
    storage_include_bucket_url: "Inclure l'URL du bucket (s3://...) dans la valeur enregistrée",
    storage_save_url: "Enregistrer l'URL au lieu du chemin de stockage",

    // ─── DateTime property ──────────────────────────────────────
    datetime_automatic_value: "Valeur automatique",

    // ─── Markdown property ──────────────────────────────────────
    markdown_paste_behavior: "Comportement au collage",

    // ─── Entity identity bar and inspector ──────────────────────
    entity_saved: "Enregistré",
    more_actions: "Plus d'actions",
    record_history: "Historique",
    inspect_record: "Inspecter l'enregistrement",
    inspect: "Inspecter",
    close_inspector: "Fermer l'inspecteur",
    open_in_live_site: "Ouvrir sur le site en ligne",

    // ─── Revision history ───────────────────────────────────────
    history_revert: "Revenir à cette version",
    history_revert_title: "Revenir à cette version des données ?",
    history_reverted: "Retour à la version sélectionnée",
    history_revert_error: "Erreur lors du retour en arrière",
    history_revert_dirty: "Enregistrez ou annulez vos modifications avant de revenir en arrière",
    history_empty: "Aucun historique disponible",
    history_empty_description: "À chaque enregistrement, une nouvelle version est créée et conservée dans l'historique.",
    history_new_entity: "L'historique n'est disponible que pour les enregistrements existants",
    history_no_more: "Plus d'historique",

    // ─── Studio: tools, groups and empty states ─────────────────
    // The admin's own three groups, read by `useNavigationGroupLabel` the same
    // way as the Studio ones below — the group *name* is an identifier the
    // ordering and the icons key off, and only the heading is translated.
    studio_group_views: "Vues",
    studio_group_admin: "Administration",
    studio_group_settings: "Paramètres",
    studio_group_database: "Base de données",
    studio_group_compute: "Calcul",
    studio_group_storage: "Stockage",
    studio_group_api: "API",
    studio_group_access_control: "Contrôle d'accès",
    studio_tool_sql: "Console SQL",
    studio_tool_sql_description: "Exécuter des requêtes SQL",
    studio_tool_js: "Console JS",
    studio_tool_js_description: "Exécuter du JavaScript",
    studio_tool_rls: "Politiques RLS",
    studio_tool_rls_description: "Sécurité au niveau des lignes",
    studio_tool_storage: "Stockage",
    studio_tool_storage_description: "Gérer les fichiers de stockage",
    studio_tool_cron: "Tâches cron",
    studio_tool_cron_description: "Gérer les tâches planifiées",
    studio_tool_schema_visualizer: "Visualiseur de schéma",
    studio_tool_schema_visualizer_description: "Diagramme ER interactif de la base de données",
    studio_tool_branches: "Branches",
    studio_tool_branches_description: "Créer et gérer des branches de base de données",
    studio_tool_backups: "Sauvegardes",
    studio_tool_backups_description: "Télécharger les sauvegardes de la base de données",
    studio_tool_api: "Explorateur d'API",
    studio_tool_api_description: "Documentation d'API interactive et tests",
    studio_tool_logs: "Explorateur de journaux",
    studio_tool_logs_description: "Journaux système et de requêtes en temps réel",
    studio_tool_api_keys: "Clés d'API",
    studio_tool_api_keys_description: "Créer et gérer des clés d'API à portée limitée",
    studio_backups_denied_title: "Vous ne pouvez pas lister les sauvegardes de ce projet",
    studio_backups_denied_hint: "Le projet n'a rien d'anormal. Lister les sauvegardes nécessite une connexion administrateur, et le compte connecté a été refusé.",
    studio_backups_read_failed: "Impossible de lire les sauvegardes de ce projet",
    studio_backups_downloading: "Téléchargement…",
    studio_backups_roles_file: "Fichier des rôles",
    studio_backups_roles_file_hint: "Le .globals.sql enregistré avec cette sauvegarde. Il recrée les rôles de base de données auxquels se réfèrent les autorisations et la sécurité au niveau des lignes du dump, et `rebase db restore` le lit à côté du .dump : gardez les deux fichiers ensemble.",
    studio_backups_no_roles_file: "Aucun fichier des rôles",
    studio_backups_no_roles_file_hint: "Aucun .globals.sql n'a été enregistré avec cette sauvegarde. Une restauration dans un nouveau Postgres s'arrête à la première autorisation accordée à un rôle de base de données qui n'y existe pas.",
    studio_cron_denied_title: "Vous ne pouvez pas lister les tâches cron de ce projet",
    studio_cron_denied_hint: "Le projet n'a rien d'anormal. L'API cron est réservée aux administrateurs, et le compte connecté a été refusé.",
    studio_cron_read_failed: "Impossible de lire les tâches cron de ce projet",
    studio_api_keys_denied_title: "Vous ne pouvez pas lister les clés d'API de ce projet",
    studio_api_keys_denied_hint: "Le projet n'a rien d'anormal. Gérer les clés d'API est une opération d'administrateur, et le compte connecté a été refusé.",
    studio_api_keys_read_failed: "Impossible de lire les clés d'API de ce projet",
    studio_api_keys_empty_title: "Aucune clé d'API pour l'instant",
    studio_api_keys_empty_hint: "Créez une clé pour permettre l'authentification de service à service",
    studio_api_keys_revoke: "Révoquer",
    studio_api_keys_select_hint: "Sélectionnez une clé d'API pour voir les détails",
    studio_api_keys_permissions: "Autorisations",
    studio_api_keys_no_permissions: "Aucune autorisation configurée",
    studio_api_keys_revoke_confirmation: "Confirmation de révocation",
    studio_api_keys_name_label: "Nom :",
    studio_api_keys_access_label: "Accès :",
    studio_api_keys_admin_granted: "Rôle d'administrateur accordé",
    studio_api_keys_admin_granted_hint: "les routes d'administration et les politiques default_admin",
    studio_api_keys_done: "Terminé",
    studio_api_keys_status_active: "Active",
    studio_api_keys_status_expired: "Expirée",
    studio_api_keys_status_revoked: "Révoquée",
    studio_api_keys_stat_status: "Statut",
    studio_api_keys_stat_last_used: "Dernière utilisation",
    studio_api_keys_stat_expires: "Expire",
    studio_api_keys_never: "Jamais",
    studio_api_keys_role_service: "Service",
    studio_api_keys_stat_rate_limit: "Limite de débit",
    studio_api_keys_rate_limit_default: "Par défaut (1000/15 min)",
    studio_api_keys_stat_created_by: "Créée par",
    studio_api_keys_copy_failed: "La copie a échoué",
    studio_branches_denied_title: "Vous ne pouvez pas lister les branches de ce projet",
    studio_branches_denied_hint: "Le projet n'a rien d'anormal. Le branchement passe par la connexion administrateur, et le compte connecté a été refusé.",
    studio_branches_read_failed: "Impossible de lire les branches de ce projet",
    studio_schema_no_collections: "Aucune collection déclarée",
    studio_schema_no_collections_body: "Il n'y a encore rien à dessiner. Ajoutez une collection dans config/collections/, ou ouvrez « Modifier les collections » pour en ajouter une ici.",
    studio_schema_introspect_hint: "Sur une base de données qui a déjà des tables, rebase schema introspect écrit les fichiers de collection pour vous.",


    // ─── Studio: RLS editor confirmations ───────────────────────
    studio_rls_enable_confirm_title: "Activer la sécurité au niveau des lignes ?",
    studio_rls_enable_confirm_body: "Tant qu'aucune politique ne l'autorise, aucune ligne de {{table}} n'est lisible. Postgres refuse par défaut.",
    studio_rls_disable_confirm_title: "Désactiver la sécurité au niveau des lignes ?",
    studio_rls_disable_confirm_body: "Toutes les politiques de {{table}} cessent de s'appliquer. Quiconque atteint la table peut lire et écrire chaque ligne.",
    studio_rls_drop_policy_title: "Supprimer cette politique ?",
    studio_rls_drop_policy_body: "{{policy}} est retirée de {{table}} dans la base de données. Rien n'est écrit dans votre code, un déploiement peut donc la rétablir.",
    studio_rls_unapplied: "Non appliquée",
    studio_rls_unapplied_tooltip: "Déclarée dans votre code, pas encore dans la base de données. Enregistrez-la ici pour planifier et appliquer le changement, ou lancez `rebase db push`.",


    // ─── Studio: empty states that name a remedy ────────────────
    studio_branches_unavailable_title: "Le branchement de base de données n'est pas disponible",
    studio_branches_unavailable_body: "Le branchement requiert un backend Postgres avec une connexion administrateur. Définissez ADMIN_CONNECTION_STRING dans l'environnement du backend.",
    studio_backups_not_configured_title: "Les sauvegardes ne sont pas configurées",
    studio_backups_not_configured_body: "Définissez BACKUP_DESTINATION sur un chemin local ou une URL s3:// ou gs://, puis créez une sauvegarde avec `rebase db backup` ou un cron planifié.",
    studio_cron_empty_title: "Aucune tâche cron enregistrée",
    studio_cron_empty_body: "Ajoutez un fichier dans backend/crons/ qui exporte par défaut une CronJobDefinition.",
    studio_read_the_docs: "Consulter la documentation"
};
